import { useCallback, useState } from "react"

const STORAGE_KEY = "kmk:recent-queries"
const MAX_QUERIES = 5

function readStored(): string[] {
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		const parsed = raw ? JSON.parse(raw) : []
		return Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : []
	} catch {
		return []
	}
}

function writeStored(queries: string[]) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(queries))
	} catch {}
}

export function useRecentQueries() {
	const [queries, setQueries] = useState<string[]>(readStored)

	const addQuery = useCallback((query: string) => {
		const trimmed = query.trim()
		if (!trimmed) return
		setQueries((prev) => {
			const next = [trimmed, ...prev.filter((q) => q !== trimmed)].slice(0, MAX_QUERIES)
			writeStored(next)
			return next
		})
	}, [])

	const clearQueries = useCallback(() => {
		setQueries([])
		writeStored([])
	}, [])

	return { queries, addQuery, clearQueries }
}
